import en from './en.json'
import sv from './sv.json'
import de from './de.json'
import es from './es.json'

const translations = {
  ...en,
  ...sv,
  ...de,
  ...es,
}

export const getTranslations = locale => translations[locale] || translations.en
